/**
 * 作者中心布局组件 - 参考 makeverse.cn 设计
 *
 * 提供带侧边栏的作者中心布局，包括：
 * - 左侧导航侧边栏（扩展宽度版本）
 * - 右侧主内容区域
 */

import React from 'react';
import { Sidebar } from './Sidebar';
import { useAuthStore } from '../../store/authStore';

interface AuthorCenterLayoutProps {
  children: React.ReactNode;
}

export const AuthorCenterLayout: React.FC<AuthorCenterLayoutProps> = ({ children }) => {
  const logout = useAuthStore(state => state.logout);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* 侧边栏 - 扩展宽度到 256px */}
      <div className="w-64 flex-shrink-0">
        <Sidebar onLogout={handleLogout} collapsed={false} />
      </div>

      {/* 主内容区 */}
      <div className="flex-1 overflow-auto" style={{ scrollbarGutter: 'stable' }}>
        {children}
      </div>
    </div>
  );
};

export default AuthorCenterLayout;
